//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    ACCOUNTS_FILTERS_SEARCH_ROLES_REQUEST,
} from 'Redux/actionTypes';

//Actions
import {
    accountFiltersSearchRolesResult,
} from 'Redux/actions';

function* searchRoles({ payload }) {
    try {
        let QUERY = `
        query searchRoles ($conditions: [RoleSearchInput], $sort: [RoleSortInput], $limit: Int, $offset: Int) {
            result: searchRoles (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    id
                    name
                }
                total
            }
        }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: [
                    {
                        fields: ["dealerId"],
                        terms: [payload],
                        exact: true
                    },
                    {
                        fields: ["isCustom"],
                        terms: [false],
                        exact: true
                    }
                ],
                limit: 1000,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );
        
        yield put(accountFiltersSearchRolesResult(data?.result?.items || []))

    } catch (exc) {
        yield put(accountFiltersSearchRolesResult([]))
        ExceptionManager(exc, 'Modules/accounts/views/main/.components/AdvancedFilters/redux/saga', 'searchRoles');
    }
}

function* watchCatalogRequests() {
    yield takeEvery(ACCOUNTS_FILTERS_SEARCH_ROLES_REQUEST, searchRoles);
}


//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchCatalogRequests)
    ]);
}